import { LanguageStrings } from "$/strings";

export const ru: LanguageStrings = {
  hello: "Привет",
  loading: "Загрузка...",
  play: "ИГРАТЬ",
  create: "СОЗДАТЬ",
  choosePetButton: "Выбрать Пета",
  lowSatietyNotification:
    "Твой питомец проголодался 🍗. Накорми его, пока не стало хуже…",
  lowCleanNotification: "Питомец испачкался 🧼. Пора принять ванну!",
  lowEnergyNotification:
    "Питомец выглядит сонным 😴. Уложи его спать, чтобы восстановить силы.",
  lowMoodNotification:
    "Питомцу скучно 🥺. Поиграй с ним, чтобы поднять настроение!",
  lowHealthNotification: `⚠️ Твоему маленькому другу сейчас очень нужна помощь!
Он чувствует себя плохо и может скоро уйти… 😢
Скорее зайди в игру и помоги ему снова почувствовать себя лучше 🐾
Твоя забота сейчас очень важна ❤️`,
  manyPoopNotification:
    "Кажется, рядом с питомцем стало грязно… убери 💩, чтобы он чувствовал себя лучше 🧹",
  petLeaveNotification:
    "Питомец ушёл… Не досмотрел, не уследил 💔 Ты можешь возродить его или завести нового друга.",
  petNotYetCreatedNotification: `🐣 Ты ещё не создал своего маленького друга!

Нажми кнопку Play, выбери пета, которого хочешь создать, тапни по яйцу — и он вылупится ✨

Если у тебя возникли проблемы с созданием пета или что-то не работает, пожалуйста, напиши нам в @telegochigame — мы будем рады помочь ❤️`,

  startCommandNoPetText: `Привет! ✨
Пора завести своего питомца 🐾
Выбери одного из друзей и помоги ему вылупиться из яйца.

🔥 Будь в курсе всего первым!
Подписывайся на @telegochigame — свежие обновления, полезные советы, подарки для подписчиков и ответы на твои вопросы.

Если хочешь пройти обучение — введи команду /help 📖
Если хочешь узнать, чей питомец живёт дольше всех — смотри /leaderboard 🏆
Если хочешь увидеть лучших игроков в мини-игры — смотри /leaderboard_game 🎮
Если хочешь посмотреть состояние своего пета - /stats 📊
Если хочешь получить бонус за ежедневный вход - /daily 🎉
Если хочешь поддержать проект - /donate ❤️
Пригласи друга и заработай 20 кристаллов 💎 — /share.`,
  startCommandHasPetText: `Добро пожаловать обратно! 🌸
Твой питомец ждёт твоего внимания. Проверь его состояние и помоги ему стать счастливым.

🔥 Будь в курсе всего первым!
Подписывайся на @telegochigame — свежие обновления, полезные советы, подарки для подписчиков и ответы на твои вопросы.

Если хочешь пройти обучение — введи команду /help 📖
Если хочешь узнать, чей питомец живёт дольше всех — смотри /leaderboard 🏆
Если хочешь увидеть лучших игроков в мини-игры — смотри /leaderboard_game 🎮
Если хочешь посмотреть состояние своего пета - /stats 📊
Если хочешь получить бонус за ежедневный вход - /daily 🎉
Если хочешь поддержать проект - /donate ❤️
Пригласи друга и заработай 20 кристаллов 💎 — /share.`,
  startCommandPetLeaveText:
    `Питомец ушёл… Не досмотрел, не уследил 💔 Ты можешь возродить его или завести нового друга.

🔥 Будь в курсе всего первым!
Подписывайся на @telegochigame — свежие обновления, полезные советы, подарки для подписчиков и ответы на твои вопросы.

Если хочешь пройти обучение — введи команду /help 📖
Если хочешь узнать, чей питомец живёт дольше всех — смотри /leaderboard 🏆
Если хочешь увидеть лучших игроков в мини-игры — смотри /leaderboard_game 🎮
Если хочешь посмотреть состояние своего пета - /stats 📊
Если хочешь поддержать проект - /donate ❤️
Пригласи друга и заработай 20 кристаллов 💎 — /share
Если хочешь получить награду за ежедневный вход - /daily 🎉`,
  secondDayNotification:
    `Ты уже хорошо заботишься о пете! Он счастлив, что ты есть🥹
Тебе доступен бонус: 5 кристаллов 💎. Получить кристалы можно по команде /daily.
Возвращайся сюда каждый день, и собирай ежедневные бонусы за заботу о питомце! ❤️`,
  petCreatedNotification: `Твой питомец {name} успешно создан!
Не забывай проведывать его, чтобы он не ушёл.

А чтобы быть в курсе всех обновлений и новых фич, заглядывай в канал 👇
@telegochigame`,
  petRevivedNotification: `Твой питомец {name} вернулся!
Не забывай проведывать его, чтобы он не ушёл.`,
  referalUserCreatedNotification:
    `Твой друг перешёл по твоей пригласительной ссылке, и ты получаешь награду {eggs} яиц!`,
  dailyCommandSuccess: `Получено: {eggs} кристаллов 💎.
Возвращайся каждый день, чтобы заботиться о питомце и получать новые бонусы! ❤️`,
  dailyCommandFail:
    `Ежедневный бонус недоступен❌ Проверь, соблюдены ли условия:
- С момента появления твоего питомца прошло 24 часа.
- Ты заглянул к питомцу после того, как прошли его первые 24 часа и он стал готов делиться бонусами.
- Тебе пришло сообщение, что можно забрать свои бонусы /daily.`,
  dailyCommandFailNoAlivePet:
    `Ежедневный бонус сейчас недоступен, потому что у тебя нет питомца❌
Заведи его — и уже через 24 часа после его появления, если ты его навестишь, сможешь получать свой ежедневный бонус 💎`,
  dailyCommandFailNotDailyStartActivated:
    `Ежедневный бонус пока недоступен❌ Прошло недостаточно времени.
Как только бонус можно будет забрать, я сразу отправлю тебе сообщение в этот чат!`,
  dailyCommandFailTodayAlreadyClaimed:
    `Ежедневный бонус сейчас недоступен, потому что ты уже забрал его сегодня❌
Возвращайся завтра за свежим бонусом! ⚡️`,
  onboarding: {
    start:
      `Сначала выбери одного из питомцев. Он появится в яйце 🥚 — помоги ему вылупиться (тапай по яйцу, пока оно не треснет!).
Когда он появится, у него будет четыре важные потребности: сытость, чистота, энергия и настроение.
Твоя задача — поддерживать счастье питомца и не дать ни одной характеристике опуститься до 0, иначе питомец уйдет навсегда 💔
За уход ты получаешь кристалы 💎 — их можно тратить на счастье питомца и восстановление всех характеристик.
Выбери, о чем тебе интересно узнать дальше:`,
    satiety: `Сытость
Питомец хочет кушать!
Чтобы покормить его, просто разбросай еду по полю, пет сам подбежит и поест😋
Если еда закончилась — купи ее за кристаллы 💎 в магазине.
Помни, что пет не может кушать самостоятельно самостоятельно😓 Нельзя просто разбросать еду по полю и уйти — пет ждет тебя, чтобы поесть!`,
    clean: `Чистота
Пет так же как и ты ходит в туалет и душ.
Периодически на поле питомец оставляет какашки 💩 — выкидывай их в мусорное ведро и получай кристаллы 💎 взамен.
Если пет слишком грязный, его нужно помыть мылом. Только аккуратно!`,
    energy: `Энергия
Питомец хочет спать 💤
Обязательно следи за сменой дня и ночи, чтобы поддерживать энергию пета.
Если питомец выспался — он проснется сам. Не забывай про него, ведь положить спать его можешь только ты 🌑
Но имей в виду: если положить пета спать слишком рано, он не сможет заснуть!`,
    mood: `Настроение
Питомец любит играть.
Играй с ним в мини-игры или, не знаю, попробуй развлечь его предметами на поле…
Играть с питомцем — единственная возможность заработать кристаллы 💎`,
    eggs: `Кристаллы
Кристаллы 💎 - внутриигровая валюта нашего тамагочи.
Они нужны тебе, чтобы покупать еду или восстанавливать характеристики до 100%.
Заработать💰 их можно играя в мини-игры или убирая какашки за петом.`,
  },
  share:
    "Пусть друг заведет себе пета и поможет получить тебе дополнительные кристаллы 💎",
  shareMessage: "Заведи себе пета и попробуй воспитать его лучше других 😼",
  shareMiniGameResultMessage:
    `Попробуй побить мой результат в мини-игре - {score}!🏆`,
  donate: `Поддержите развитие Telegochi! 🌟
Выберите количество Telegram Stars, которое хотите задонатить.
Ваш вклад помогает нам поддерживать и улучшать игру.

Или используйте /donate <сумма> для произвольной суммы. Пример: /donate 100`,
  donateSuccess:
    "Спасибо за поддержку! Ваш донат сильно поможет в развитии проекта.",
  leaderboardTitle: "🏆 Таблица лидеров - Топ 10 самых долгоживущих питомцев",
  leaderboardEntry: "#{position} {username} - {days} дней",
  leaderboardYourPosition: "\n\nВаш питомец: {username} - {days} дней",
  leaderboardNoPet: "\n\nУ вас еще нет живого питомца.",
  gameLeaderboardTitle:
    "🎮 Таблица лидеров мини-игр - Топ 10 лучших результатов",
  gameLeaderboardEntry: "#{position} {username} - {score} очков",
  gameLeaderboardYourPosition: "\n\nВаш питомец: {username} - {score} очков",
  gameLeaderboardNoPet: "\n\nУ вас еще нет живого питомца.",
  statsTitle: "🐾 Состояние вашего питомца",
  statsInfo:
    "Сытость: {satiety}%\nЧистота: {clean}%\nЭнергия: {energy}%\nНастроение: {mood}%\nКристаллы: {coins} 💎\nЕда: {food} 🍗\nКакашки: {poop} 💩",
  statsNoPet:
    "У вас еще нет живого питомца. Создайте его, чтобы начать играть!",

  petNames: {
    cat: "Кот",
    dog: "Собака",
    capy: "Капибара",
    parrot: "Попугай",
    shark: "Акула",
  },

  yourPetDead: "Твой пет умер...",
  savePet: "Спаси его пока не\nпоздно!",
  saveProgress: "Сохрани весь прогресс и предметы!",
  loseProgress: "Весь прогресс будет потерян!",
  or: "или",
  resurrectButton: "Воскресить",
  resurrectByAdButton: "Воскресить с рекламой",
  createNewButton: "Создать нового",
  settings: "Настройки",
  catchFoodScene: {
    score: "Счёт",
    miss: "Пропуск",
    obstacleCatched: "Отравился",
    again: "Заново",
    leaderboard: "Лидерборд",
    continueTitle: "Продолжить игру?",
    continueButton: "Продолжить",
    resultsButton: "К результатам",
    timer: "Осталось времени",
    share: "Поделиться",
    exit: "Выход",
    newRecord: "Новый рекорд!",
    leaderboardError: "Не удалось загрузить таблицу лидеров. Попробуйте снова.",
  },
  currencyShopScene: {
    getEggs: "Получить яйца",
    invite: "Пригласить",
    motivationText: "Пригласи друга и получи яйца, когда он \nсоздаст пета!",
    supportText: "Поддержать \nразработчиков ❤️",
    ourChannelText: "Наш канал",
    exit: "Выход",
    donateError: "Ошибка обработки доната. Пожалуйста, попробуйте позже.",
  },
  statRestoreOverlay: {
    notEnoughCoins: "Недостаточно яиц!",
    energy: "Энергия",
    satiety: "Сытость",
    mood: "Настроение",
    clean: "Чистота",
    restoreWithAd: "Восстановить",
    adWarningText: "будет показана реклама",
  },
  settingsOverlay: {
    music: "Музыка",
    sound: "Звуки",
  },
  sceneTransitions: {
    backToPet: "Назад к питомцу!",
    eggsPurchased: "Яйца куплены!",
    brakeEgg: "Разбивай яйцо",
    choosePet: "Выбери своего питомца ^_^",
    petIsBack: "Твой питомец вернулся!",
    petIsDead: "Твой питомец ушёл 😭",
    createPet: "Создай своего питомца ^_^",
    welcomeBack: "С возвращением ^_^",
    goingBack: "Назад...",
    home: "Домой...",
    shop: "Магазин",
    startingGame: "Начинаем игру...",
    gamesList: "Мини-игры",
    
  },
  foodShopOverlay: {
    title: "Купить еду",
    buyFood: "+1 Еда",
    currentFood: "Еда",
    notEnoughCoins: "Недостаточно яиц!",
  },
};
